import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { ActionItemModel } from '@src/app/modules/actions';
import { TranslateService } from '@ngx-translate/core';

import { ChatMemberModel } from '../types';

@Component({
  selector: 'chat-members-list-item',
  templateUrl: './chat-members-list-item.component.html',
  styleUrls: ['./chat-members-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ChatMembersListItemComponent {
  private readonly translateService = inject(TranslateService);

  @Input() member?: ChatMemberModel;
  @Input() actions?: ActionItemModel[];

  getRole() {
    return this.member?.isChatAdmin
      ? this.translateService.instant('components.internalMessenger.labels.admin')
      : undefined;
  }
}
